export default __webpack_public_path__ + "static/rockwell-5398fcb1813ac3dac8195b69e49393f9.woff2";